import React, { useState } from 'react';
import { get, post } from '../../Services/api';
import './sign_up.css'
import { auth } from '../../Services/firebase';
import { createUserWithEmailAndPassword, GoogleAuthProvider, signInWithPopup, sendEmailVerification } from 'firebase/auth';
import google_icon from '../../resources/google-icon.png'
import Button from '@mui/material/Button';
import { BsEyeFill, BsEyeSlash } from "react-icons/bs";
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import IconButton from '@mui/material/IconButton';
import { useNavigate } from 'react-router-dom';
import { CgDanger } from "react-icons/cg";
import { useAuth } from '../../Components/AuthContext/AuthContext';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
function SignUp() {
    const [showPassword, setShowPassword] = useState(false)
    const [passNotMatch, setPassNotMatch] = useState(false)
    const [emailInUse, setEmailInUse] = useState(false)
    const { setIsCreatingUser } = useAuth();

    const navigate = useNavigate();

    function goToPage(path) {
        navigate(path);
    }

    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email: ''
    });

    const [password, setPassword] = useState('')
    const [password_confirm, setPasswordConfirm] = useState('')
    const [agreed, setAgreed] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
        if (name == 'email')
            setEmailInUse(false)
    };


    function createUser() {
        setIsCreatingUser(true)
        createUserWithEmailAndPassword(auth, formData.email, password)
            .then(async user => {
                const params = { ...formData, uid: user.user.uid };
                await post('/api/user/create-user', params)
                setIsCreatingUser(false)
            })
            .catch((error) => {
                const errorCode = error.code;
                console.log(error)
                if (errorCode === "auth/email-already-in-use") {
                    setEmailInUse(true)
                }
            });
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!agreed) {
            alert('You must agree to the Terms & Conditions and Privacy Policy to create an account.');
            return;
        }
        if (password === password_confirm) {

            const userExist = await get('/api/public/user/user-exist',
                {
                    email: formData.email
                }
            );
            if (!userExist) {
                createUser()
            } else {
                setEmailInUse(true)
            }
        } else {
            setPassNotMatch(true)
        }
    };

    function continueWithGoogle() {
        if (!agreed) {
            alert('You must agree to the Terms & Conditions and Privacy Policy to continue with Google.');
            return;
        }
        const provider = new GoogleAuthProvider();
        signInWithPopup(auth, provider)
            .catch((error) => {
                alert("An error occured while logging in the user.")
            });
    }

    const ColorButton = styled(Button)(({ theme }) => ({
        color: 'white',
        height: '60px',
        backgroundColor: '#235539',
        '&:hover': {
            backgroundColor: '#247e4b',
        },
    }));

    const GoogleButton = styled(Button)(({ theme }) => ({
        color: '#21201F',
        height: '55px',
        border: '1px solid #21201F',
        display: 'flex',
        '&:hover': {
            backgroundColor: '#21201f15',
            border: '1px solid #21201F',
        },
    }));


    return (
        <div className='login_div flex flex_column gap_20 justify_center'>
            <h4 className='login_header font_weight_700 font_size_28 text_align_center'>Create an account</h4>

            <form onSubmit={handleSubmit} className='flex flex_column gap_20 justify_center'>
                <div className='flex gap_12'>
                    <TextField
                        id="outlined-error"
                        label="First Name"
                        name="first_name"
                        value={formData.first_name} onChange={handleChange} required
                    />
                    <TextField
                        id="outlined-error-helper-text"
                        label="Last Name"
                        name="last_name"
                        value={formData.last_name} onChange={handleChange} required
                    />
                </div>

                <TextField label="Email Address" variant="outlined" color='primary' type="email" name="email" onChange={handleChange} value={formData.email} required
                    helperText={emailInUse ? "Email is already in use" : ''}
                    FormHelperTextProps={{
                        style: { color: emailInUse ? 'red' : 'inherit' }, // Change color based on condition
                    }}
                />

                <FormControl variant="outlined">
                    <InputLabel htmlFor="outlined-adornment-password">Password*</InputLabel>
                    <OutlinedInput label="Password*" variant="outlined"
                        name="password" value={password} onChange={(e) => { setPassword(e.target.value) }}
                        required
                        type={showPassword ? 'text' : 'password'}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={() => setShowPassword(!showPassword)}
                                >
                                    {showPassword ? <BsEyeSlash /> : <BsEyeFill />}
                                </IconButton>
                            </InputAdornment>
                        } />
                </FormControl>

                <TextField label="Confirm Password" variant="outlined" color='primary' type="password" name="password_confirm"
                    onChange={(e) => { setPasswordConfirm(e.target.value); setPassNotMatch(false) }} value={password_confirm} required
                    helperText={passNotMatch ? "Password does not match" : ''}
                    FormHelperTextProps={{
                        style: { color: emailInUse ? 'red' : 'inherit' }, // Change color based on condition
                    }} />

                <FormControlLabel
                    control={
                        <Checkbox
                            checked={agreed}
                            onChange={e => setAgreed(e.target.checked)}
                            name="agree"
                            color="primary"
                        />
                    }
                    label={
                        <span>
                            I agree to the{' '}
                            <a
                                href="https://prepwize.ai/terms-and-conditions/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="sign-up-terms-link"
                            >
                                Terms & Conditions
                            </a>{' '}
                            and{' '}
                            <a
                                href="https://prepwize.ai/privacy-policy/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="sign-up-terms-link"
                            >
                                Privacy Policy
                            </a>
                        </span>
                    }
                />
                <ColorButton type="submit" variant="contained">Create Account</ColorButton>
            </form>



            <p className='text_align_center'>Already have an account? {' '}
                <span className='login_forgot_password cursor_pointer width_fit_content' onClick={() => goToPage('/login')}>Login</span>
            </p>

            <div className='login_or_div align_center gap_12'>
                <div className='login_or_line_div'></div>
                <p className='font_size_12'>OR</p>
                <div className='login_or_line_div'></div>
            </div>

            <GoogleButton variant="outlined" onClick={continueWithGoogle}
                startIcon={<img src={google_icon} width={20} />}>Continue with Google</GoogleButton>
        </div>
    )
}

export default SignUp